import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { AuthHttpInterceptor } from "@auth0/auth0-angular";
import { Observable } from "rxjs";

export class AuthHttpInterceptorExtended  extends AuthHttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log(req.url);
    if (req.url.endsWith('DEC/GetSolarSchools') || req.url.endsWith('DEC/GetDECSchools') || req.url.endsWith('DEC/GetDECSchoolById') || req.url.endsWith('DST/GetDSTSchools') || req.url.endsWith('DST/GetDSTSchoolById') || req.url.endsWith('PublicBookshop/GetBookShops')) {
      return  next.handle(req);
    }
    else {
      return super.intercept(req, next);
    }
  }
}
